module.exports = __webpack_public_path__ + "img/digital-signage-installation.42834854.jpg";